/**
 * @file NotificationPageFrame.js
 * @description Shared page shell for notification editor and template views.
 **/

const NotificationPageFrame = ({
    title,
    headerContent,
    children,
    footerContent = null,
    titleClassName = 'page-title float-start ms-4 m-0',
    headerClassName = 'col-auto',
    bodyClassName = '',
}) => (
    <div className="page-content">
        <div className="card">
            <div className="card-body px-0 py-4">
                <div className="d-flex justify-content-between align-items-center position-relative pb-3">
                    <h2 className={titleClassName}>{title}</h2>
                    <div className={headerClassName}>{headerContent}</div>
                </div>

                <div className={bodyClassName}>{children}</div>

                {footerContent}
            </div>
        </div>
    </div>
);

export default NotificationPageFrame;
